import "./Blog-Detail.css";
export function Blog3() {
  return (
    <div className="des-container">
      <div className="des-heading">
        Case Study: How We Helped PMI FortMill Grow Their Business with Smart
        Marketing
      </div>
      <img
        className="des-img blog-img-bottom"
        src="https://productionhussmestorage.blob.core.windows.net/hussmeassets/blog3-2-img.jpg"
      />

      <div className="details-container">
        <div className="des-sec-1">
          <div className="des-blog-title">
            <div className="des-intro">Introduction</div>
          </div>
          <div className="intro-description">
            In a competitive market, having a great product or service isn’t
            enough—you need the right marketing strategy to connect with your
            audience, build trust, and drive growth.
            <br /> At Hussme, we specialize in helping brands turn potential
            into performance. Today, we’re sharing the story of how we helped
            PMI FortMill, a Real Estate, scale their business
            with smart, strategic marketing.
          </div>
        </div>
        <div className="title-points-blog">
          <div className="des-point">The Challenge</div>
          <div className="title-points-des">
            PMI FortMill came to us facing several key challenges:
          </div>
          <ul>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Low brand visibility in a competitive niche
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Ineffective social media engagement
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Poor conversion rates on their website
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              No clear brand identity or messaging
            </li>
          </ul>
          <div className="title-points-des txt-indent">
            Their team had the passion and product—but not the strategy or
            digital presence to match.
          </div>
        </div>

        <div className="title-points-blog">
          <div className="des-point">Our Approach</div>
          <div className="title-points-des txt-indent">
            We didn’t believe in one-size-fits-all solutions. So we started with
            a deep dive discovery session to understand their brand, audience,
            and business goals. Then, we developed a custom plan built around
            four pillars:
          </div>
        </div>
        <div className="title-points-blog">
          <div className="des-point">1. Brand Identity Overhaul</div>
          <div className="title-points-des">
            We helped PMI FortMill clarify their positioning and visual
            identity to reflect their core values
          </div>
          <ul>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Redesigned their logo and color palette for a modern, memorable
              look
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Created brand messaging that spoke directly to their ideal
              customer
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Developed a tone of voice guide for consistent communication
            </li>
          </ul>
        </div>
        <div className="title-points-blog">
          <div className="des-point">2. Website Optimization</div>
          <div className="title-points-des">
            Their website wasn’t doing its job. We focused on redesigning it to
            be a high-converting sales tool.
          </div>
          <ul>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Improved site navigation and mobile responsiveness
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Rewrote key pages for clarity, SEO, and user intent
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Added lead capture forms, social proof, and better CTAs
            </li>
          </ul>
        </div>
        <div className="title-points-blog">
          <div className="des-point">3. Targeted Social Media Strategy</div>
          <div className="title-points-des">
            We built and executed a content plan that prioritized value-driven,
            on-brand content.
          </div>
          <ul>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Created weekly content calendars with branded graphics and posts
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Launched targeted ad campaigns on Instagram and Facebook
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Engaged with their community to increase organic reach
            </li>
          </ul>
        </div>
        <div className="title-points-blog">
          <div className="des-point">4. Smart Email Marketing</div>
          <div className="title-points-des">
            To nurture leads and increase repeat customers, we launched a clean,
            automated email funnel:
          </div>
          <ul>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Welcome series for new subscribers
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Promo campaigns synced with key product launches
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              Monthly newsletters to share updates and drive traffic
            </li>
          </ul>
        </div>
        <div className="title-points-blog">
          <div className="des-point">The Results</div>
          <div className="title-points-des">
            After just 90 days, here’s what we achieved together:
          </div>
          <ul>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              📈 52% increase in website traffic
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              🚀 3x growth in qualified leads
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              💬 Engagement rate on social media up by 75%
            </li>
            <li>
              <div className="point">
                <img src="" alt="" />
              </div>
              💰 Sales increased by 38% compared to the previous quarter
            </li>
          </ul>
          <div className="title-points-des txt-indent">
            But beyond the numbers, the real win was this: PMI FortMill now has
            a brand they’re proud of and a strategy that continues to deliver
            long-term results.
          </div>
        </div>

        <div className="des-sec-2">
          <div className="point-container">
            <div className="des-point">Client Testimonial</div>
          </div>
          <div className="spl-point-left">
            “Working with Hussme completely changed our marketing game. They
            helped us find our voice, reach more people, and most
            importantly—grow our business. We finally feel like we’re in control
            of our brand.”
          </div>
          <span className="blog-text-center">
            "People don’t buy what you do. They buy why you do it." – Simon
            Sinek
          </span>
        </div>

        <div className="des-sec-1">
          <div className="des-blog-title">
            <div className="des-intro">Ready to Grow Smarter?</div>
          </div>
          <div className="intro-description">
            This isn’t just a success story. It’s proof that strategy-driven
            marketing works—when it’s done right. If you’re tired of guessing
            and ready to grow, we’d love to help.
            <br />
            👉 Schedule your free consultation today
          </div>
        </div>
      </div>
    </div>
  );
}
